import { NavigateFunction } from "react-router-dom";

type NavigateBackOrToMainOptions = {
  language?: string;
};

export const navigateBackOrToMain = (navigate: NavigateFunction, options?: NavigateBackOrToMainOptions): void => {
  const language = options?.language;
  const fallbackPath = language ? `/${language}` : `/`;

  const idx = typeof window !== "undefined" ? (window.history.state as any)?.idx : undefined;
  const canGoBack =
    (typeof idx === "number" && idx > 0) || (typeof window !== "undefined" && window.history.length > 1);

  if (canGoBack) {
    navigate(-1);
    return;
  }

  navigate(fallbackPath, { replace: true });
};
